<template>
  <div class="flex flex-col gap-4">
    <AdapterItem
      v-for="item in items"
      :key="item.adapter.id"
      :adapter="item.adapter"
      :service="item.service"
      :is-replacement="item.isReplacement === true"
      :replacement-service="item.replacementService"
      :show-remove="
        removableIds ? removableIds.includes(item.adapter.id) : false
      "
      @change="$emit('change', $event)"
      @remove="$emit('remove', $event)"
      @exchange="$emit('exchange', $event)"
      @service-type-change="$emit('serviceTypeChange', $event)"
    />
  </div>
</template>
<script setup lang="ts">
import AdapterItem from './AdapterItem.vue';
import type { DisplayAdapterItem } from '@/composables/useAdapters';

const props = defineProps<{
  items: DisplayAdapterItem[];
  removableIds?: string[];
}>();

defineEmits<{
  (e: 'change', adapter: any): void;
  (e: 'exchange', payload: any): void;
  (e: 'remove', adapter: any): void;
  (e: 'serviceTypeChange', payload: any): void;
}>();
</script>
